module.exports = __webpack_public_path__ + "img/loader1.2f570355.png";